import DeliveryWizardComponent from './exportables/DeliveryWizardComponent'
import DeliveryWizardModal from './exportables/DeliveryWizardModal'

const DeliveryWizard = {
  AsModal: DeliveryWizardModal,
  AsComponent: DeliveryWizardComponent
}

export default DeliveryWizard
